import React, { memo } from 'react';
import { useGlobalAddressContext } from '../../../../AddressInfo';
import { addressReducerTypes } from '../../../../Reducer';
import Select from '../../../../../../../../../Elements/ids/InputElements/Select';
import { mapExistingAddressesToSelect } from './Functions';

const ExistingAddressSelector = () => {
  const { addressDispatch, addressState } = useGlobalAddressContext();

  return (
    <Select
      defaultValue={addressState.address?.id ?? 0}
      options={mapExistingAddressesToSelect(addressState.addressList)}
      onChange={e => {
        addressDispatch({
          type: addressReducerTypes.selectExistingAddress,
          addressId: parseInt(e.target.value),
        });
      }}
      cssClasses="max-width"
    />
  );
};

export default memo(ExistingAddressSelector);
